var map = {
	"./image-gallery/style/index.tsx": 101,
	"./version/style/index.tsx": 102,
	"./view/style/index.tsx": 103
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98;



//////////////////
// WEBPACK FOOTER
// ./components ^\.\/[^_][\w-]+\/style\/index\.tsx?$
// module id = 98
// module chunks = 0